export const STRINGS = {
  NO_LAW_FIRM_NAME: "No Law Firm Name",
  NO_CLIENT_NAME: "No Client Name",
  NO_DESCRIPTION: "No Description",
  LAW_FIRM: "Law Firm",
  CLIENT: "Client",
  CLIENT_COUNT: "Client Count",
  NO_ACTING_USER_NAME: "No Acting User Name",
  NO_PROVIDER_NAME: "No Provider Name",
  NO_DUE_DATE_AVAILABLE: "No Due Date Available",
  PAST_DUE: "This item is past the due date!",
};
